import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class PatrimonioLiquido extends BaseEntity{
    public dataBase: Date;
    public valor: string;
    public usuarioADResponsavel: string;
    public nomeUsuarioADResponsavel: string;
    public dataRegistro: Date;
}
